module.exports = __webpack_public_path__ + "static/media/description.a1b997aa.svg";